import {
	Box,
	Divider,
	Typography,
	Stack,
	Paper,
} from '@mui/material'
import React from 'react'
import { ChangeOrderComponent } from '../../types/Work/ChangeOrder'
import { getChangeOrderAttachments } from '../../services/changeOrderService'
import ImageModal from '../core/ImageModal'

interface ComponentsListProps {
	changeOrders: ChangeOrderComponent[]
}

export default function ComponentsList({
	changeOrders,
}: ComponentsListProps) {

	return (
		<Paper variant='outlined' sx={{ p: 2, backgroundColor: 'background.paper' }}>
			<Stack spacing={1}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
					<Typography variant='subtitle1' sx={{ fontWeight: 600 }}>
						Change Order Components
					</Typography>
				</Box>
				<Divider />
				{changeOrders.map((changeOrder) => (
					<Box
						key={changeOrder.id}
						sx={{
							display: 'flex',
							alignItems: 'flex-start',
							gap: 2,
							py: 1,
							'&:not(:last-child)': {
								borderBottom: '1px solid',
								borderColor: 'divider',
							},
						}}
					>
						<Box sx={{ minWidth: 200 }}>
							<Typography variant='body2' sx={{ fontWeight: 500 }}>
								{changeOrder.componentName}
							</Typography>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
								<Typography variant='body2' color='text.secondary'>
									ID: {changeOrder.id}
								</Typography>
								{changeOrder.hasAttachment ? (
									<ImageModal
										itemId={changeOrder.id}
										imageUrlService={getChangeOrderAttachments}
										padding={0}
									/>
								) : null}
							</Box>
						</Box>
						<Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flex: 1 }}>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 120 }}>
								<Typography variant='body2' color='text.secondary'>
									Original:
								</Typography>
								<Typography variant='body2'>
									{changeOrder.originalValue} {changeOrder.uom}
								</Typography>
							</Box>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 120 }}>
								<Typography variant='body2' color='text.secondary'>
									Proposed:
								</Typography>
								<Typography
									variant='body2'
									sx={{
										color:
											changeOrder.proposedValue > changeOrder.originalValue
												? 'success.main'
												: 'error.main',
										fontWeight: 500,
									}}
								>
									{changeOrder.proposedValue} {changeOrder.uom}
								</Typography>
							</Box>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 120 }}>
								<Typography variant='body2' color='text.secondary'>
									Diff:
								</Typography>
								<Typography
									variant='body2'
									sx={{
										color:
											changeOrder.proposedValue > changeOrder.originalValue
												? 'success.main'
												: 'error.main',
										fontWeight: 500,
									}}
								>
									{(changeOrder.proposedValue - changeOrder.originalValue).toFixed(2)}{' '}
									{changeOrder.uom}
								</Typography>
							</Box>
						</Box>
					</Box>
				))}
			</Stack>
		</Paper>
	)
}
